import { Slide, ToastContent, ToastOptions, Zoom, toast as reactToast } from 'react-toastify';
import Icon from '../components/icons/icon';

const toastOptions: ToastOptions = {
  position: 'bottom-center',
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'dark',
  className:
    'bg-[#1c1c1c] rounded-[12px] flex items-center py-[16px] px-[13px] min-h-content max-w-[100vw] lg:w-[560px] lg:ml-[calc(-560px_/_4)]',
  bodyClassName: 'p-0 m-0 font-medium text-[16px] leading-[24px]',
  transition: Zoom,
  closeButton: () => <Icon icon="Close" stroke="#9CA3AF" />,
};

export function toast(
  message: ToastContent,
  type: 'success' | 'warning' | 'error' = 'success',
  customToastOptions?: ToastOptions,
) {
  switch (type) {
    case 'success':
      return reactToast(message, {
        ...toastOptions,
        ...customToastOptions,
        icon: () => <Icon icon="CheckCircleBroken" stroke="var(--success-500)" />,
        type: 'success',
      });

    case 'warning':
      return reactToast(message, {
        ...toastOptions,
        ...customToastOptions,
        icon: () => <Icon icon="InfoCircle" stroke="var(--warning-500)" />,
        type: 'warning',
      });

    case 'error':
      return reactToast(message, {
        ...toastOptions,
        ...customToastOptions,
        icon: () => <Icon icon="XCircle" stroke="var(--error-500)" />,
        type: 'error',
      });
  }
}

const ecommerceToastOptions: ToastOptions = {
  position: 'top-right',
  autoClose: 8000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
  theme: 'light',
  className: 'w-[320px] py-[10px] px-[12px] !min-h-fit rouned-[6px] border-solid border',
  bodyClassName: '!p-0 !m-0 !min-h-fit font-medium text-[12px] leading-[1.333333333]',
  transition: Slide,
};

export function ecommerceToast(
  message: ToastContent,
  type: 'success' | 'warning' | 'error' = 'success',
  customToastOptions?: ToastOptions,
  useOldToast: boolean = false,
) {
  switch (type) {
    case 'success':
      if (useOldToast) {
        // @ts-expect-error yorent
        ShowJsSystemMessage(message, false);
        return;
      }

      return reactToast(message, {
        ...ecommerceToastOptions,
        className: `${ecommerceToastOptions.className} border-success-1100 bg-success-200 text-success-1000`,
        ...customToastOptions,
        type: 'success',
        icon: () => <Icon icon="InfoCircle" stroke="var(--success-1000)" />,
        closeButton: () => <Icon icon="Close" stroke="var(--success-1000)" />,
      });

    case 'warning':
      return reactToast(message, {
        ...ecommerceToastOptions,
        className: `${ecommerceToastOptions.className} border-warning-500 bg-warning-100 text-warning-500`,
        ...customToastOptions,
        type: 'warning',
        icon: () => <Icon icon="InfoCircle" stroke="var(--warning-500)" />,
        closeButton: () => <Icon icon="Close" stroke="var(--warning-500)" />,
      });

    case 'error':
      if (useOldToast) {
        // @ts-expect-error yorent
        ShowJsSystemMessage(message, true);
        return;
      }

      return reactToast(message, {
        ...ecommerceToastOptions,
        className: `${ecommerceToastOptions.className} border-error-500 bg-error-200 text-[#1a1c25]`,
        ...customToastOptions,
        icon: () => <Icon icon="InfoCircle" stroke="var(--error-500)" />,
        closeButton: () => <Icon icon="Close" stroke="var(--error-500)" />,
        type: 'error',
      });
  }
}
